import styled from '@emotion/styled';
import { Colors, Elevations, viewportWidthSmall } from '@paddl/storybook';

const {
  white
} = Colors;

export const ProfilePageWrapper = styled.div`
  background-color: ${white};

  .MuiGrid-container {
    @media (max-width: ${viewportWidthSmall}) {
      display: block;
      width: calc(100vw - 32px);
      margin-left: 0;

      > .MuiGrid-item {
        padding-left: 0;
      }
    }
  }
`;

export const ScrollToTopWrapper = styled.div`
  div {
    position: fixed;
    bottom: 132px;
    background: ${white};
    cursor: pointer;
    border-radius: 100%;
    border: none;
    box-shadow: ${Elevations.elevation};
    transition: display 0.25s ease;
  }
`;
